export enum CountdownTimerPart {
  HOURS,
  MINUTES,
  SECONDS,
}
